// extracted by mini-css-extract-plugin
export default {"rename":"Rename_rename__nF0jv","is-disabled":"Rename_is-disabled__OOon4","rename-modal":"Rename_rename-modal__HXpoU"};